import type { CancelToken, Method } from 'axios';
import axios from 'axios';
import Bugsnag from '@bugsnag/js';
import { nanoid } from 'nanoid';
import logger from './logging/logger';

export async function apiFetch<T>({
    endpoint,
    params,
    method = 'get',
    fullResponse,
    cancelToken
}: {
    endpoint: string;
    params?: Record<string, $TSFixMe> | null;
    method?: Method;
    fullResponse?: boolean;
    cancelToken?: CancelToken;
}): Promise<T> {
    try {
        const response = await axios({
            headers: {
                'X-Transaction-ID': nanoid()
            },
            method,
            url: endpoint,
            data: params,
            withCredentials: true,
            cancelToken
        });
        return fullResponse ? response : response.data;
    } catch (err: $TSFixMe) {
        if (!axios.isCancel(err)) {
            // do not log cancelled requests as errors
            const error = err.response || err;
            logger.error('Api Fetch Error', { error });

            Bugsnag.notify(err, (event) => {
                event.addMetadata('extra', { method, endpoint });
            });
        }

        throw err;
    }
}
